import { StandardDialog, StandardDialogProps } from '@roc/ui';
import React, { ReactNode, useEffect, useState } from 'react';
import { CustomTask, LoanChatRoom } from './customTask';
import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';
import { observer } from 'mobx-react';
import { useGeneralTasksStore } from '../../hooks/useGeneralTasksStore';
import { isNil } from '@roc/feature-utils';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      marginTop: '0px'
    },
  }),
);

interface CustomTaskDialogProps extends StandardDialogProps {
  open: boolean;
  title: string;
  taskId: number;
  readOnly?: boolean;
  allowVertScroll?: boolean;//allow custom content to add vertical scroll bar in case of overflow
  loanChatRoom?: LoanChatRoom;
}

export const CustomTaskDialog = observer(({
  open,
  title,
  taskId,
  readOnly,
  handleClose,
  dialogContent,
  dialogActions,
  allowVertScroll = true,
  loanChatRoom,
  ...props
}: CustomTaskDialogProps) => {
  const clases = useStyles();
  const [selectedTabIndex, setSelectedTabIndex] = useState<number>(0);
  const { generalTasksStore } = useGeneralTasksStore();
  const { openChatTabForTaskId, isChatForParentTask } = generalTasksStore;

  useEffect(() => {
    if (taskId) {
      setSelectedTabIndex(0);
    } else {
      // Call through the store instance (not a destructured reference) so
      // this MobX action keeps its `this` binding — see the same pattern
      // already used in handleClose below.
      generalTasksStore.setOpenChatTabForTaskId(null);
    }
  }, [taskId]);

  useEffect(() => {
    if (openChatTabForTaskId && openChatTabForTaskId === taskId) {
      setSelectedTabIndex(isNil(dialogContent) ? 0 : 1);
    }
  }, [openChatTabForTaskId]);

  const handleTabChange = (value: number) => {
    if (!(isChatForParentTask && value === 0)) {
      setSelectedTabIndex(value);
    }
  }


  return (
    <StandardDialog
      open={open}
      title={'Task'}
      maxWidth={'lg'}
      removeContentBox
      handleClose={(e) => {
        generalTasksStore.setOpenChatTabForTaskId(null);
        handleClose(e);
      }}
      dialogContent={
        <CustomTask
          title={title}
          taskId={taskId}
          readOnly={readOnly}
          customContent={dialogContent}
          selectedTabIndex={selectedTabIndex}
          setSelectedTabIndex={handleTabChange}
          allowVertScroll={allowVertScroll}
          loanChatRoom={loanChatRoom}
        />
      }
      dialogContentclasses={clases}
      dialogActions={selectedTabIndex === 0 ? dialogActions : null}
      {...props}
    />
  );
});
